// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__31Eop","clinicsSelect":"styles_clinicsSelect__3V0CA"};